<template>
	<el-container class="healthy page-x" direction="vertical">
		<div class="search-x">
			<div class="search-item">
				<span class="label">机构</span>
				<el-select v-model="searchBox.orgLevel" placeholder="请选择">
					<el-option
						v-for="item in orgLevelList"
						:key="item.id"
						:label="item.name"
						:value="item.id"
					>
					</el-option>
				</el-select>
			</div>
			<div class="search-item">
				<span class="label">渠道</span>
				<el-select
					v-model="searchBox.sellChannels"
					multiple
					clearable
					placeholder="请选择"
				>
					<el-option
						v-for="item in channelList"
						:key="item.code"
						:label="item.name"
						:value="item.code"
					>
					</el-option>
				</el-select>
			</div>
			<div class="search-item">
				<span class="label">日期</span>
				<el-date-picker
					v-model="searchBox.calMonth"
					type="month"
					:editable="false"
					:clearable="false"
					value-format="yyyyMM"
					placeholder="选择月"
				>
				</el-date-picker>
			</div>
			<el-button v-auth="'sa_order_page'" type="primary" @click="toSearch"
				>查询</el-button
			>
			<el-button
				v-auth="'sa_order_page'"
				type="primary"
				@click="() => ($root.showPage = false)"
				>重置</el-button
			>
		</div>
		<div class="cont-x">
			<div class="table-x" ref="tableBox">
				<el-table
					v-loading="loading"
					:data="tableData"
					border
					class="mb20"
				>
					<el-table-column
						prop="orgName"
						align="center"
						label="机构名称"
					>
					</el-table-column>
					<el-table-column
						v-for="item in channelDataList"
						:key="item.code"
						:prop="item.key"
						align="center"
						:label="item.name"
					>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<!-- <div class="pagenation-x">
            <div class="pagination mb20">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="searchBox.pageNo"
                    layout="total,  prev, pager, next, jumper"
                    :total="total"
                    background
                >
                </el-pagination>
            </div>
        </div> -->
	</el-container>
</template>

<script>
	// 带全选功能的下拉框
	import SelectAll from "@/components/SelectAll";
	export default {
		name: "Customer",
		components: {
			SelectAll,
		},
		data() {
			return {
				orgLevelList: [
					{
						id: "1",
						name: "一级",
					},
					{
						id: "2",
						name: "二级",
					},
				],
				channelList: [
					{
						code: 1130002,
						name: "其他渠道（团险）",
						key: "otherInsurance",
					},
					{
						code: 1130003,
						name: "个人保险渠道",
						key: "personalInsurance",
					},
					{
						code: 1130004,
						name: "多元行销渠道（银保）",
						key: "bankInsurance",
					},
					{
						code: 1130013,
						name: "经代渠道",
						key: "economicAgent",
					},
					{
						code: 1130006,
						name: "新业务渠道",
						key: "networkSale",
					},
					{
						code: 1130014,
						name: "收展渠道",
						key: "developChannel",
					},
					{
						code: "all",
						name: "销售渠道",
						key: "all",
					},
				],
				channelDataList: [],
				// table表格
				loading: false,
				tableData: [], // table数据
				total: 0,
				timeDefaultShow: "",
				// 查询条件
				searchBox: {
					orgLevel: "1",
				}, // 搜索条件
				value2: "", // 日期
			};
		},
		created() {
			// 面包导航
			this.$root.breadList = [
				{ name: "报表中心", link: "" },
				{ name: "客户量报表", link: "" },
			];
			this.channelDataList = this.channelList;
		},
		mounted() {
			this.dataTime();
			this.getData();
		},
		methods: {
			// 设置日期选择默认为上月及当月
			dataTime() {
				var nowDate = new Date();
				var date = {
					year: nowDate.getFullYear(),
					month: nowDate.getMonth() + 1,
					day: nowDate.getDate(),
				};
				let dayDate =
					date.year +
					"" +
					(date.month >= 10 ? date.month : "0" + date.month);
				this.$set(this.searchBox, "calMonth", dayDate.toString());
			},
			/**
			 * 搜索按钮
			 */
			toSearch() {
				let arr = [];
				this.searchBox.sellChannels.forEach((item) => {
					this.channelList.forEach((content) => {
						if (item == content.code) {
							arr.push(content);
						}
					});
				});
				if (
					this.searchBox.sellChannels &&
					this.searchBox.sellChannels.length > 0
				) {
					this.channelDataList = arr;
				} else {
					this.channelDataList = this.channelList;
				}
				this.getData();
			},
			/**
			 * 获取数据
			 */
			getData() {
				this.loading = true;
				let params = Object.assign({}, this.searchBox);
				Object.keys(params).forEach((key) => {
					if (
						Object.prototype.toString.call(params[key]) ===
						"[object Array]"
					) {
						params[key] =
							params[key].length == 1
								? params[key][0]
								: params[key].join(",");
					}
				});
				if (!params.sellChannels) delete params.sellChannels;
				this.axios
					.get(this.getApiUrl("customerReport"), {
						params,
					})
					.then((res) => {
						this.loading = false;
						if (res.code === 1) {
							this.tableData = res.data.rows || [];
							this.total = res.data.total;
						} else {
							this.$message.warning(res.msg);
						}
					})
					.catch((err) => {
						this.loading = false;
					});
			},
			/**
			 * 换页
			 */
			handleCurrentChange(val) {
				this.getData();
			},
		},
	};
</script>

<style lang="scss" scoped>
</style>